<!--
 * @Author: xing.huang
 * @Date: 2021-10-27 14:29:49
 * @LastEditTime: 2022-05-24 10:59:23
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\alarm\ExceptionConfig\exceptionConfigEdit.vue
 * 
-->
<template>
  <el-dialog title="编辑" :lock-scroll="false" :visible.sync="isShowDialog" width="500px" center :close-on-click-modal="false" @close="cancelConfig">
    <el-form :model="editForm" :rules="rules" ref="editForm" style="width:100%;" class="config_exception_edit_form">
      <el-row :gutter="20" style="margin-bottom:0px">
        <el-col :span="24">
          <span class="title  is-my-required">事件名称：</span>
          <el-form-item prop="anomalyName" class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
            <el-input size="small" disabled v-model="editForm.anomalyName" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom:0px" v-if="editForm.anomalyCode == 'procedure_complete_overdue' || editForm.anomalyCode == 'procedure_starts_overdue'">
        <el-col :span="16">
          <span class="title is-my-required">触发条件：</span>
          <el-form-item class="value" prop="triggersMode" :rules="rules.triggersMode">
            <el-radio-group v-model="editForm.triggersMode">
              <el-radio :label="0">即时触发</el-radio>
              <el-radio :label="1">延迟触发</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6" style="margin-left:-36px" v-if="editForm.triggersMode == 1">
          <el-form-item prop="conditionHour" class="value">
            <el-input size="small" style="width:60px" v-model="editForm.conditionHour" maxlength="4" placeholder="延期时间"></el-input><span>小时</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom:0px" v-if="editForm.anomalyCode == 'order_complete_overdue' || editForm.anomalyCode == 'order_starts_overdue'">
        <el-col :span="13">
          <span class="title  is-my-required">触发条件：</span>
          <el-form-item prop="conditionDay" class="value">
            <el-input size="small" style="width:120px" v-model="editForm.conditionDay" maxlength="5" placeholder="延期天数"></el-input>
            <span style="margin-left:4px">天</span>
          </el-form-item>
        </el-col>
        <el-col :span="9" style="margin-left:-36px">
          <el-form-item prop="conditionClock" class="value">
            <el-input size="small" style="width:120px" v-model="editForm.conditionClock" maxlength="5" placeholder="触发时间"></el-input>
            <span style="margin-left:4px">点</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom:0px" v-if="editForm.anomalyCode == 'product_dull'">
        <el-col :span="16">
          <span class="title is-my-required">触发条件：</span>
          <el-form-item prop="conditionHour" class="value">
            <el-input size="small" style="width:180px" v-model="editForm.conditionHour" maxlength="5" placeholder="呆滞时长"></el-input>
            <span>小时</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom:0px" v-if="editForm.anomalyCode == 'spot_inspection_delay'">
        <el-col :span="16">
          <span class="title is-my-required">触发条件：</span>
          <el-form-item prop="conditionClock" class="value">
            <el-input size="small" style="width:120px" v-model="editForm.conditionClock" maxlength="5" placeholder="触发条件"></el-input>
            <span>点</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom:0px" v-if="editForm.anomalyCode == 'product_overstock'">
        <el-col :span="16">
          <span class="title is-my-required">触发条件：</span>
          <el-form-item prop="conditionQuantity" class="value">
            <el-input size="small" style="width:120px" v-model="editForm.conditionQuantity" maxlength="5" placeholder="积压数量"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom:0px" v-if="editForm.anomalyCode == 'product_overstock'">
        <el-col :span="16">
          <span class="title is-my-required">判断时间：</span>
          <el-form-item prop="conditionClock" class="value">
            <el-input size="small" style="width:120px" v-model="editForm.conditionClock" maxlength="5" placeholder="触发时间"></el-input>
            <span>点</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        :gutter="20"
        style="margin-bottom:0px"
        v-if="editForm.anomalyCode == 'self_check_overtime' || editForm.anomalyCode == 'patrol_check_overtime' || editForm.anomalyCode == 'first_check_overtime'"
      >
        <el-col :span="16">
          <span class="title is-my-required">触发条件：</span>
          <el-form-item prop="conditionMinute" class="value">
            <el-input size="small" style="width:180px" v-model="editForm.conditionMinute" maxlength="5" placeholder="超时时长"></el-input>
            <span>分钟</span>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20" style="margin-bottom:0px">
				<el-col :span="24">
					<span class="title">通知方式：</span>
					<el-form-item class="value" prop="notificationWay"  >
						<el-checkbox-group v-model="editForm.notificationWay" >
							<el-checkbox  label="shortNote" >短信</el-checkbox>
							<el-checkbox  label="email" >邮箱</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-col>
			</el-row> -->
      <el-row :gutter="20" style="margin-bottom:0px">
        <el-col :span="24">
          <span style="font-size: 16px;font-weight: bold;" class="title">处理流程:</span>
          <el-form-item class="value" prop="configEvent">
            <el-checkbox-group v-model="editForm.configEvent" @change="checkEventChange">
              <el-checkbox disabled label="confirm">确认</el-checkbox>
              <el-checkbox label="handle">处理</el-checkbox>
              <el-checkbox label="audit">审核</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="flow-warp">
        <div v-if="editForm.configEvent.includes('confirm')" @click="changeFow('confirm')" class="flow" :class="{ flowActive: activeName == 'confirm' }">确认</div>
        <div v-if="editForm.configEvent.includes('handle')" @click="changeFow('handle')" class="flow" :class="{ flowActive: activeName == 'handle' }">处理</div>
        <div v-if="editForm.configEvent.includes('audit')" @click="changeFow('audit')" class="flow" :class="{ flowActive: activeName == 'audit' }">审核</div>
      </div>
      <div class="config-warp">
        <div class="event-config confirm" v-if="activeName == 'confirm'">
          <div class="config-user-tab">
            <div class="config-tab-item" :class="{ tabActive: editForm.confirmFlow.activeType == 1 }" @click="changeActive(editForm.confirmFlow, 1)">
              <span style="margin-top:14px;display: inline-block">确<br />认<br />人</span>
            </div>
            <div class="config-tab-item" :class="{ tabActive: editForm.confirmFlow.activeType == 2 }" @click="changeActive(editForm.confirmFlow, 2)">
              <span style="margin-top:4px;display: inline-block">逐<br />级<br />上<br />报</span>
            </div>
          </div>
          <div class="config-user-content">
            <div class="config-user" v-if="editForm.confirmFlow.activeType == 1">
              <el-radio-group v-model="editForm.confirmFlow.personnelType" style="margin-left:20px">
                <el-radio v-for="item in confirmWayList" style="display:block;margin-top:20px" :key="item.type" :label="item.type">
                  {{ item.name }}
                </el-radio>
                <el-select
                  size="small"
                  multiple
                  collapse-tags
                  v-model="editForm.confirmFlow.flowGeneralList"
                  placeholder="请选择"
                  style="display: inline-block;position: relative;top: -22px;left: 112px;"
                >
                  <el-option v-for="item in userList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                </el-select>
              </el-radio-group>
            </div>
            <div class="level-by-level" v-if="editForm.confirmFlow.activeType == 2">
              <el-table :data="editForm.confirmFlow.flowStepList" :maxHeight="170" tooltip-effect="dark">
                <el-table-column label="序号" width="50">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="等待时间" min-width="120" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-input placeholder="请输入内容" v-model="scope.row.waitingTime" maxlength="5">
                      <template slot="append">分钟</template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="上报人" min-width="160" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-select size="small" multiple collapse-tags v-model="scope.row.userIdList" placeholder="请选择" style="display: inline-block;">
                      <el-option v-for="item in userList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label=" " width="80" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <i class="el-icon-my-add" @click="addItem(scope.$index, editForm.confirmFlow.flowStepList)"></i>
                    <i class="el-icon-my-remove" v-if="editForm.confirmFlow.flowStepList.length > 1" @click="delItem(scope.$index, editForm.confirmFlow.flowStepList)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div class="event-config confirm" v-if="activeName == 'handle'">
          <div class="config-user-tab">
            <div class="config-tab-item" :class="{ tabActive: true }">
              <span style="margin-top:40px;display: inline-block">逐<br />级<br />上<br />报</span>
            </div>
          </div>
          <div class="config-user-content">
            <div class="level-by-level">
              <el-table :data="editForm.handleFlow.flowStepList" :maxHeight="170" tooltip-effect="dark">
                <el-table-column label="序号" width="50">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="等待时间" min-width="120" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-input placeholder="请输入内容" v-model="scope.row.waitingTime" maxlength="5">
                      <template slot="append">分钟</template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="上报人" min-width="160" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-select size="small" multiple collapse-tags v-model="scope.row.userIdList" placeholder="请选择" style="display: inline-block;">
                      <el-option v-for="item in userList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label=" " width="80" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <i class="el-icon-my-add" @click="addItem(scope.$index, editForm.handleFlow.flowStepList)"></i>
                    <i class="el-icon-my-remove" v-if="editForm.handleFlow.flowStepList.length > 1" @click="delItem(scope.$index, editForm.handleFlow.flowStepList)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div class="event-config confirm" v-if="activeName == 'audit'">
          <div class="config-user-tab">
            <div class="config-tab-item" :class="{ tabActive: editForm.auditFlow.activeType == 1 }" @click="changeActive(editForm.auditFlow, 1)">
              <span style="margin-top:14px;display: inline-block">审<br />核<br />人</span>
            </div>
            <div class="config-tab-item" :class="{ tabActive: editForm.auditFlow.activeType == 2 }" @click="changeActive(editForm.auditFlow, 2)">
              <span style="margin-top:4px;display: inline-block">逐<br />级<br />上<br />报</span>
            </div>
          </div>
          <div class="config-user-content">
            <div class="config-user" v-if="editForm.auditFlow.activeType == 1">
              <el-table :data="editForm.auditFlow.flowGeneralList" :maxHeight="170" tooltip-effect="dark">
                <el-table-column label="序号" width="50">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="name" label="审核人" min-width="100" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-select size="small" v-model="scope.row.userId" placeholder="请选择" style="display: inline-block;">
                      <el-option v-for="item in auditList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label=" " width="80" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <i class="el-icon-my-add" @click="addAuditItem(scope.$index, editForm.auditFlow.flowGeneralList)"></i>
                    <i class="el-icon-my-remove" v-if="editForm.auditFlow.flowGeneralList.length > 1" @click="delAuditItem(scope.$index, editForm.auditFlow.flowGeneralList)"></i>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <div style="margin-top: 20px">
								<span style="margin-left:10px">选择审核人:</span>
								<el-select @change="selectEditUserChange($event)"  size="small" multiple v-model="editForm.auditFlow.flowGeneralList" placeholder="请选择"  style="display: inline-block;">
									<el-option v-for="item in auditList" :key="item.value" :label="item.name" :value="item.value"></el-option>
								</el-select>
								<div id="tags"  style="margin-left:10px">
									<el-tag @close='delTag(tag.value)' v-for="tag in tags" :key="tag.value" closable > {{tag.name}}</el-tag>
								</div>
							</div> -->
            </div>
            <div class="level-by-level" v-if="editForm.auditFlow.activeType == 2">
              <el-table :data="editForm.auditFlow.flowStepList" :maxHeight="170" tooltip-effect="dark">
                <el-table-column label="序号" width="50">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="等待时间" min-width="120" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-input placeholder="请输入内容" v-model="scope.row.waitingTime" maxlength="5">
                      <template slot="append">分钟</template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="上报人" min-width="160" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-select size="small" multiple collapse-tags v-model="scope.row.userIdList" placeholder="请选择" style="display: inline-block;">
                      <el-option v-for="item in userList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label=" " width="80" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <i class="el-icon-my-add" @click="addItem(scope.$index, editForm.auditFlow.flowStepList)"></i>
                    <i class="el-icon-my-remove" v-if="editForm.auditFlow.flowStepList.length > 1" @click="delItem(scope.$index, editForm.auditFlow.flowStepList)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <div style="text-align: center;margin-top:20px">
      <el-button type="primary" @click="submitConfig">确 定</el-button>
      <el-button @click="cancelConfig">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Sortable from "sortablejs";
import CommonUtils from "../../../util/CommonUtils";
export default {
  name: "ExceptionConfigEdit",
  props: {
    isShow: Boolean,
    anomalyName: String,
    anomalyCode: String,
    id: Number
  },
  data() {
    return {
      userList: [],
      auditUserList: [],
      confirmWayList: [{ type: 1, name: "指定确认人" }],
      auditWayList: [{ type: 1, name: "指定审核人" }],
      configList: [
        {
          type: 4,
          name: "工序逾期开工",
          anomalyCode: "procedure_starts_overdue",
          confirmWay: [
            { type: 0, name: "任务制定人和首工序执行人" },
            { type: 1, name: "指定确认人" }
          ],
          auditWayList: [
            { type: 1, name: "指定审核人" },
            { name: "事件确认人", type: 4 }
          ]
        }, //   及时触发   延时触发  小时
        {
          type: 5,
          name: "工单逾期开工",
          anomalyCode: "order_starts_overdue",
          confirmWay: [
            { type: 0, name: "任务制定人和首工序执行人" },
            { type: 1, name: "指定确认人" }
          ],
          auditWayList: [
            { type: 1, name: "指定审核人" },
            { name: "事件确认人", type: 4 }
          ]
        }, // 延迟天  延迟点
        {
          type: 6,
          name: "工序逾期完工",
          anomalyCode: "procedure_complete_overdue",
          confirmWay: [
            { type: 0, name: "任务制定人" },
            { type: 1, name: "指定确认人" }
          ],
          auditWayList: [
            { type: 1, name: "指定审核人" },
            { name: "事件确认人", type: 4 }
          ]
        }, //及时触发   延时触发  小时
        {
          type: 7,
          name: "工单逾期完工",
          anomalyCode: "order_complete_overdue",
          confirmWay: [
            { type: 0, name: "任务制定人" },
            { type: 1, name: "指定确认人" }
          ],
          auditWayList: [
            { type: 1, name: "指定审核人" },
            { name: "事件确认人", type: 4 }
          ]
        }, //延迟天  延迟点
        {
          type: 9,
          name: "在制品呆滞",
          anomalyCode: "product_dull",
          confirmWay: [{ type: 1, name: "指定确认人" }],
          auditWayList: [
            { type: 1, name: "指定审核人" },
            { name: "事件确认人", type: 4 }
          ]
        }, //小时
        {
          type: 10,
          name: "在制品积压",
          anomalyCode: "product_overstock",
          confirmWay: [{ type: 1, name: "指定确认人" }],
          auditWayList: [
            { type: 1, name: "指定审核人" },
            { name: "事件确认人", type: 4 }
          ]
        }, //积压数量
        {
          type: 11,
          name: "母卷质量检超时",
          anomalyCode: "self_check_overtime",
          confirmWay: [{ type: 1, name: "指定确认人" }],
          auditWayList: [
            { type: 1, name: "指定审核人" },
            { name: "事件确认人", type: 4 }
          ]
        }, //分钟
        {
          type: 12,
          name: "子卷质量检超时",
          anomalyCode: "patrol_check_overtime",
          confirmWay: [{ type: 1, name: "指定确认人" }],
          auditWayList: [
            { type: 1, name: "指定审核人" },
            { name: "事件确认人", type: 4 }
          ]
        }, //分钟
        {
          type: 13,
          name: "自检超时",
          anomalyCode: "first_check_overtime",
          confirmWay: [{ type: 1, name: "指定确认人" }],
          auditWayList: [
            { type: 1, name: "指定审核人" },
            { name: "事件确认人", type: 4 }
          ]
        }, //分钟 //审核：事件确认人 +其他用户
        {
          type: 14,
          name: "点检超时",
          anomalyCode: "spot_inspection_delay",
          confirmWay: [{ type: 1, name: "指定确认人" }],
          auditWayList: [
            { type: 1, name: "指定审核人" },
            { name: "事件确认人", type: 4 }
          ]
        }, //分钟 //审核：事件确认人 +其他用户
        {
          type: 15,
          name: "点检超时",
          anomalyCode: "other_anomalies",
          confirmWay: [{ type: 1, name: "指定确认人" }],
          auditWayList: [
            { type: 1, name: "指定审核人" },
            { name: "事件确认人", type: 4 }
          ]
        } //分钟 //审核：事件确认人 +其他用户
      ],
      W: false,
      isShowDialog: false,
      activeName: "confirm", //选中事件
      editForm: {
        anomalyCode: 0, //异常事件类型  1-设备异常-手动、2-缺料异常、3-工艺异常、4-工序逾期开工、5-工单逾期开工、6-工序完工逾期、7-工单完工逾期、//8-设备异常-自动、9-在制品呆滞、10-在制品积压、11-母卷质量检超时、12-子卷质量检超时、13-自检超时
        anomalyName: "", //异常事件名称
        toggleCondition: 1, //触发条件 0-及时触发 1-延时触发
        conditionMinute: null, //延迟触发时间分钟
        conditionHour: null, //延迟触发时间小时
        conditionDay: null, //延迟天数
        conditionClock: null,
        conditionQuantity: null, //在制品积压数量
        // notificationWay:['email','shortNote'],      //通知方式  //1-邮箱通知  //2-短信通知
        configEvent: ["confirm", "handle", "audit"], //配置事件
        confirmFlow: {
          //异常确认
          activeType: 1, //1-确认人   2-逐级上报
          personnelType: 1, //确认方式 0-任务制定人和首工序执行人，1-指定确认人，2-由上报人员指定，3-班组长，4-事件确认人，5-事件提交人
          flowGeneralList: [], //确认人多选
          flowStepList: [
            {
              waitingTime: null, //逐级上报时间
              userIdList: [1] //逐级上报人员
            },
            {}
          ]
        },
        handleFlow: {
          //异常处理
          personnelType: null,
          flowStepList: [
            {
              waitingTime: null, //逐级上报时间
              userIdList: [2] //逐级上报人员
            }
          ]
        },
        auditFlow: {
          //异常审核
          activeType: 1, //1-审核人   2-逐级上报
          flowGeneralList: [], //审核人  -1事件上报人、-2事件确认人、 其他用户id
          personnelType: 1, //确认方式 1-指定确认人，4-事件确认人，

          flowStepList: [
            {
              waitingTime: null, //逐级上报时间
              userIdList: [3] //逐级上报人员
            }
          ]
        }
      },
      rules: {
        triggersMode: [{ required: true, message: "请选择触发方式", trigger: "blur" }],
        conditionHour: [
          { required: true, message: "请输入延迟时间", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (value) {
                let reg = /^(([1-9]{1}\d*)(\.\d{1})?|(0{1})(\.[1-9]{1}))$/;
                if (!reg.test(value)) {
                  callback(`大于零且可保留1位小数`);
                } else {
                  callback();
                }
              } else {
                callback("延迟时间不能为空");
              }
            },
            trigger: "blur"
          }
        ],
        conditionHour1: [
          { required: true, message: "请输入判断周期", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (value) {
                let reg = /^(([1-9]{1}\d*)(\.\d{1})?|(0{1})(\.\d{1}))$/;
                if (!reg.test(value)) {
                  callback(`大于零且可保留1位小数`);
                } else {
                  callback();
                }
              } else {
                callback("请输入判断周期");
              }
            },
            trigger: "blur"
          }
        ],
        conditionDay: [
          {
            validator(rule, value, callback) {
              if (value) {
                let reg = /^([1-9]{1}\d*)$/;
                if (!reg.test(value)) {
                  callback(new Error("延迟天数必须为正整数"));
                } else {
                  callback();
                }
              } else {
                callback("延迟天数不能为空");
              }
            },
            trigger: "blur"
          }
        ],
        conditionClock: [
          {
            validator(rule, value, callback) {
              if (value) {
                let reg = /^([1-9]{1}\d*)$/;
                if (!reg.test(value)) {
                  if (value == 0) {
                    callback();
                  } else {
                    callback(new Error("触发时间不小于0并且为整数"));
                  }
                } else {
                  if (value >= 24) {
                    callback(new Error("触发时间必须小于24"));
                  } else {
                    callback();
                  }
                }
              } else {
                log(value, 232);
                if (value == "0") {
                  callback();
                } else {
                  callback(new Error("触发时间不能为空"));
                }
              }
            },
            trigger: "blur"
          }
        ],
        conditionQuantity: [
          {
            validator(rule, value, callback) {
              if (value) {
                let reg = /^([1-9]{1}\d*)$/;
                if (!reg.test(value)) {
                  callback(new Error("积压数量必须为正整数"));
                } else {
                  callback();
                }
              } else {
                callback("积压数量不能为空");
              }
            },
            trigger: "blur"
          }
        ],
        conditionMinute: [
          {
            validator(rule, value, callback) {
              if (value) {
                let reg = /^([1-9]{1}\d*)$/;
                if (!reg.test(value)) {
                  callback(new Error("超时时间必须为正整数"));
                } else {
                  callback();
                }
              } else {
                callback("超时时间不能为空");
              }
            },
            trigger: "blur"
          }
        ]
      },
      auditList: [],
      tags: []
    };
  },

  async mounted() {
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
    this.loadUserList();
  },

  methods: {
    async loadUserList(workerName) {
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/listWorker", params: { workerName } });
      this.userList = data;
      this.auditList = [{ id: -1, name: "事件确认人", value: -1 }, ...data];
    },

    cancelConfig() {
      this.$refs.editForm.resetFields();
      this.$parent.showEdit = false;
    },
    test() {
      var that = this;
      var el = document.getElementById("tags");
      // 常用
      // new Sortable(el, {
      // 	onEnd: function (evt) {
      // 		// 获取排序之后的data数据
      // 		that.tags.splice(evt.newIndex, 0, that.tags.splice(evt.oldIndex, 1)[0])
      // 		var newArray = that.tags.slice(0)
      // 		that.tags = []
      // 		that.$nextTick(function () {
      // 			that.tags = newArray
      // 		})
      // 	}
      // })
    },
    delTag(ev) {
      this.tags = this.tags.filter(f => f.value != ev);
      let list = CommonUtils.cloneObj(this.editForm.auditFlow.flowGeneralList);
      list = list.filter(item => item != ev);
      this.$set(this.editForm.auditFlow, "flowGeneralList", list);
    },

    selectEditUserChange(ev) {
      ev.forEach(item => {
        let find = this.tags.find(f => f.value == item);
        if (!find) {
          this.tags.push({
            value: item,
            name: this.auditList.find(a => a.value == item).name
          });
        }
      });
      if (this.tags.length > ev.length) {
        this.tags = this.tags.filter(f => ev.includes(f.value));
      }
    },

    submitConfig() {
      this.$refs["editForm"].validate(valid => {
        if (valid) {
          this.editForm.confirmFlow.flowStepList = this.editForm.confirmFlow.flowStepList.filter(f => f.waitingTime || f.userIdList.length > 0);
          this.editForm.handleFlow.flowStepList = this.editForm.handleFlow.flowStepList.filter(f => f.waitingTime || f.userIdList.length > 0);
          this.editForm.auditFlow.flowStepList = this.editForm.auditFlow.flowStepList.filter(f => f.waitingTime || f.userIdList.length > 0);
          let pass1 = true,
            pass2 = true,
            pass3 = true;
          pass1 = this.check(this.editForm.confirmFlow.flowStepList, "确认");
          if (!pass1) {
            return false;
          }
          if (this.editForm.configEvent.includes("handle")) {
            pass2 = this.check(this.editForm.handleFlow.flowStepList, "处理");
          }
          if (!pass2) {
            return false;
          }
          if (this.editForm.configEvent.includes("audit")) {
            pass3 = this.check(this.editForm.auditFlow.flowStepList, "审核");
          }
          if (!pass3) {
            return false;
          }
          if (this.editForm.confirmFlow.personnelType == 1 && this.editForm.configEvent.includes("handle") && this.editForm.anomalyCode != "other_anomalies") {
            let len = this.editForm.confirmFlow.flowGeneralList.length;
            if (len == 0) {
              this.$message.error("指定确认人不能为空");
              return;
            }
          }
          let flowGeneralList = [];
          if (this.editForm.configEvent.includes("audit")) {
            let len = this.editForm.auditFlow.flowGeneralList.length;
            if (len == 0) {
              this.$message.error("指定审核人不能为空");
              return;
            }

            if (this.editForm.auditFlow.flowGeneralList.length == 1 && !this.editForm.auditFlow.flowGeneralList[0].userId) {
              this.$message.error("指定审核人不能为空");
              return;
            }

            flowGeneralList = this.editForm.auditFlow.flowGeneralList.map(item => item.userId).filter(item => item);
            if (this.editForm.auditFlow.flowGeneralList.length == 0) {
              this.$message.error("指定审核人不能为空");
              return;
            }
          }
          this.editForm.auditFlow.flowGeneralList = flowGeneralList;
          this.$RequestUtil.post({
            url: "/api/anomalyResponse/edit",
            type: "sync",
            params: this.editForm,
            success: res => {
              if (res.code == 0) {
                this.$message.success("编辑成功");
                this.$parent.showEdit = false;
              } else {
                this.$message.error(res.msg || res.message);
              }
            }
          });
        }
      });
    },

    check(data, title) {
      let isPass = true;
      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        if ((item.waitingTime && item.userIdList.length == 0) || (!item.waitingTime && item.userIdList.length > 0)) {
          console.log(item, 124);
          this.$message.error(title + "逐级上报上报人和上报时间必须同时存在");
          isPass = false;
          break;
        } else if (item.waitingTime && item.userIdList > 0) {
          let reg = /^([1-9]{1}\d*)$/;
          if (!reg.test(item.waitingTime)) {
            this.$message.error(title + "逐级上报上时间必须为正整数");
            isPass = false;
            break;
          }
        }
      }
      return isPass;
    },

    changeActive(configEvnt, type) {
      configEvnt.activeType = type;
    },
    checkEventChange(ev) {
      if (!ev.includes(this.activeName)) {
        this.activeName = "confirm";
      }
    },
    changeFow(name) {
      log(this.editForm.configEvent, name);

      this.activeName = name;
      if (name == "audit") {
        setTimeout(() => {
          this.test();
        }, 0);
      }
    },

    addItem(index, list) {
      list.splice(index + 1, 0, {});
    },

    delItem(index, list) {
      list.splice(index, 1);
    },

    addAuditItem(index, list) {
      list.splice(index + 1, 0, {});
    },

    delAuditItem(index, list) {
      list.splice(index, 1);
    },
    async loadDetail() {
      let { data, code } = await this.$RequestUtil.getAsync({ url: "/api/anomalyResponse/detail", type: "sync", params: { id: this.id } });
      if (code == 0) {
        return data;
      } else {
        return {};
      }
    }
  },
  watch: {
    isShow: async function(newVal, oldVal) {
      this.isShowDialog = this.isShow;
      if (this.isShow) {
        let editForm = await this.loadDetail();
        this.editForm = editForm;
        if (!this.editForm.confirmFlow.flowGeneralList) {
          this.editForm.confirmFlow.flowGeneralList = [];
        }

        if (!this.editForm.auditFlow.flowGeneralList || (this.editForm.auditFlow.flowGeneralList && !this.editForm.auditFlow.flowGeneralList[0])) {
          this.editForm.auditFlow.flowGeneralList = [{ userId: -1 }];
        } else {
          this.editForm.auditFlow.flowGeneralList = this.editForm.auditFlow.flowGeneralList.map(item => {
            return { userId: item };
          });
        }
        if (!this.editForm.confirmFlow.flowStepList || (this.editForm.confirmFlow.flowStepList && !this.editForm.confirmFlow.flowStepList[0])) {
          this.editForm.confirmFlow.flowStepList = [{ waitingTime: null, userIdList: [] }];
        } else {
          this.editForm.confirmFlow.flowStepList.forEach(item => {
            if (!item.userIdList) {
              item.userIdList = [];
            }
          });
        }
        if (!this.editForm.handleFlow.flowStepList || (this.editForm.handleFlow.flowStepList && !this.editForm.handleFlow.flowStepList[0])) {
          this.editForm.handleFlow.flowStepList = [{ waitingTime: null, userIdList: [] }];
        } else {
          this.editForm.handleFlow.flowStepList.forEach(item => {
            if (!item.userIdList) {
              item.userIdList = [];
            }
          });
        }
        if (!this.editForm.auditFlow.flowStepList || (this.editForm.auditFlow.flowStepList && !this.editForm.auditFlow.flowStepList[0])) {
          this.editForm.auditFlow.flowStepList = [{ waitingTime: null, userIdList: [] }];
        } else {
          this.editForm.auditFlow.flowStepList.forEach(item => {
            if (!item.userIdList) {
              item.userIdList = [];
            }
          });
        }
        if (this.editForm.configEvent.length == 0) {
          this.editForm.configEvent = ["confirm", "handle", "audit"];
          this.editForm.confirmFlow.personnelType = 1;
          this.editForm.auditFlow.personnelType = 1;
        }
        this.activeName = "confirm";
        this.editForm.anomalyName = this.anomalyName;
        this.editForm.anomalyCode = this.anomalyCode;
        this.editForm.id = this.id;
        // this.selectEditUserChange(this.editForm.auditFlow.flowGeneralList)
        this.$set(this.editForm.confirmFlow, "activeType", 1);
        this.$set(this.editForm.auditFlow, "activeType", 1);
        this.confirmWayList = (this.configList.find(item => item.anomalyCode == this.anomalyCode) || {}).confirmWay;
        this.auditWayList = (this.configList.find(item => item.anomalyCode == this.anomalyCode) || {}).auditWayList;
      }
    }
  }
};
</script>

<style scoped>
.title {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  display: inline-block;
  text-align: right;
  width: 70px;
}
.is-my-required:before {
  content: "*";
  color: #f56c6c;
  left: 0px;
  top: 6px;
  font-size: 20px;
  position: absolute;
}
.value {
  display: inline-block;
}
.flow-warp {
  display: flex;
}
.flow {
  flex: 1;
  max-width: 160px;
  margin-right: -10px;
  width: 100%;
  height: 28px;
  line-height: 28px;
  text-align: center;
  color: #23272a;
  font-size: 14px;
  background: url("/static/img/flow.png");
  background-size: 100% 100%;
  cursor: pointer;
}

.flowActive {
  color: #fff;
  background: url("/static/img/flow-active.png");
  background-size: 100% 100%;
}
.config-warp {
  margin-top: 10px;
  width: 100%;
  height: 172px;
  border: 1px solid #e1e3ec;
  border-radius: 4px;
}
.event-config {
  display: flex;
  height: 100%;
}
.config-user-tab {
  width: 32px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.config-tab-item {
  flex: 1;
  color: #9e9ca0;
  font-size: 14px;
  border-radius: 1px 0px 0px;
  text-align: center;
  cursor: pointer;
  border: 1px solid;
  border-left: none;
  border-bottom: none;
}
.tabActive {
  background: rgb(18, 131, 237, 0.05);
  color: #1283ed;
}
.config-user-content {
  flex: 1;
  width: calc(100% - 32px);
}
</style>
<style>
.config_exception_edit_form .el-input-group__append {
  padding: 0 10px;
}
#tags .el-tag {
  margin-right: 20px;
  cursor: pointer;
  margin-top: 10px;
}
.config_exception_edit_form .level-by-level.el-input__inner {
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/alarm/ExceptionConfig/exceptionConfigEdit.vue